export const costs = [
  'Prepari ogni lezione su ambiente e sostenibilità da zero, cercando materiale sparso su internet',
  'Spiegare ecosistemi, cicli, inquinamento e clima senza immagini chiare è difficile',
  'Non hai attività, progetti e verifiche pronte da usare in classe',
  'Perdi ore a preparare materiali invece di dedicarti agli studenti',
];
